import React, { useEffect, useState } from 'react';
import WishlistCard from '../../components/WishlistCard';
import './styles.js';
import { useFilterContext } from '../../context/filter_context';
import axios from 'axios';
import { useUserContext } from '../../context/user_context';
import Wrapper from './styles';
import { Link } from 'react-router-dom';
import { IoMdHeartEmpty } from 'react-icons/io';
import { Loading } from '../../components/index.js';
import { FaHeart } from 'react-icons/fa';
import { useCartContext } from '../../context/cart_context';
import { useDisclosure } from '@chakra-ui/react';
import { formatPrice } from '../../utils/helpers.js';
const WishlistPage = () => {
  const { filtered_products: products, grid_view } = useFilterContext();
  const [wishlistItems, setWishlistItems] =useState([]);
  const [isLoading, setIsLoading]=useState(false)
  const { currentUser } = useUserContext();
   const { handlecartButton, setMainColor } = useCartContext();
    const { isOpen, onOpen, onClose } = useDisclosure();
const [cartButtonText, setCartButtonText] = useState('');
  useEffect(() => {
    document.title = 'Mukunda Jewelery | Wishlist';
  }, []);

  const fetchData = async () => {
    setIsLoading(true)
    try {
      const userid = currentUser?.id;
      if (userid) {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_HOST}/api/user/wishlistitem/${userid}`
        );
        
        setWishlistItems(response.data.data);
      }
      setIsLoading(false)
    } catch (error) {
      console.error('Error fetching wishlist items:', error);
    }
    setIsLoading(false);
  };

  const removeFromWishlist = async (id) => {
    const data = {
      wishlistItem: id,
    };
    const userid = currentUser?.id;
    const response = await axios.delete(
      `${process.env.REACT_APP_BACKEND_HOST}/api/user/wishlistitem/${userid}`,
      { data }
    );
    await fetchData();
  };

  useEffect(() => {
    fetchData();
  }, [currentUser, products]);

  const handleMoveToBag = async(data,id) => {
    setIsLoading(true)
     await handlecartButton(
      data.id,
      1,
      currentUser,
      setCartButtonText,
      onOpen,
      data.productCode,
      data.bestOffers,
      data.taxPrice,
      data.weight,
      data?.discountPercentage,
      data.price,
      data.price
    );
    removeFromWishlist(id)
    setIsLoading(false)
  };
  if (wishlistItems.length < 1 && !isLoading) {
    return (
      <Wrapper className='page-100 h-full flex flex-col justify-center items-center'>
        <div className='empty h-full flex flex-col justify-center items-center'>
          <h2 style={{ marginBottom: '5px' }}>Your wishlist is empty</h2>
          <Link
            to='/collections'
            className='btn'
            style={{ backgroundColor: '#D3A143' }}
          >
            fill it
          </Link>
        </div>
      </Wrapper>
    );
  }

  return (
    <div
      className='flex flex-col bg-white rounded-lg  
          w-[90vw] sm:w-[400px] md:w-[90vw] p-4 z-[50]'
    >
      <Link to='/collections'>
        <p className='text-sm underline text-black cursor-pointer mb-4'>
          {' '}
          Continue to shopping
        </p>
      </Link>
      <h1 className='w-full text-black font-bold text-lg mb-4 text-center flex sm:justify-start items-center'>
        Wishlist{' '}
        <span className='text-sm font-[400]'>
          ({wishlistItems.length} products)
        </span>
      </h1>

      {!isLoading && (
        <div className='w-full flex justify-center flex-wrap gap-4 m-4'>
          {wishlistItems.map((e) => (
            <div
              key={e.id}
              className='border-b border-[#008FAB40] pb-3 last:border-none md:w-[30%] sm:w-full'
            >
              <div className='w-full flex flex-col gap-3 sm:gap-4 items-center justify-between'>
                <img
                  src={e.productImageUrl[0]}
                  alt={e.name}
                  className='w-full h-72 lg:h-80 rounded-md object-fill'
                />

                <div className='w-full flex-1 flex justify-start flex-col text-sm sm:text-base'>
                  <p className='font-medium text-gray-800 line-clamp-2 leading-tight'>
                    {e.description}
                  </p>
                  <div className='flex gap-2 items-center justify-between mt-1'>
                    <>
                      <p className='font-bold text-black text-sm sm:text-base'>
                        {formatPrice(e?.price)}
                      </p>
                      {e.discountPercentage > 0 && (
                        <p className='text-xs line-through text-gray-500'>
                          {formatPrice(Number(e?.subPrice)+Number(e?.discountPrice))}
                        </p>
                      )}
                      {e.discountPercentage > 0 && (
                        <p className='text-xs text-red-600'>
                          ({formatPrice(e?.discountPrice)} Off)
                        </p>
                      )}
                    </>
                    <FaHeart
                      className='cursor-pointer                    '
                      fill='#D3A143'
                    />
                  </div>
                  <button
                    className='mt-2 w-full text-xs sm:text-sm border border-[#22222280] text-[#222222] rounded-md px-2 py-1 bg-white transition'
                    onClick={() => handleMoveToBag(e,e.id)}
                  >
                    Move to Bag
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
      {isLoading && <Loading />}
    </div>
  );
};

export default WishlistPage;
